import { Grid, Stack } from '@mui/material';
import { useEffect, useState } from 'react';
import { OtsService } from '../../../../Apis/OtsService';
import LmDialog from '../../../../components/common/LmDialog';
import VegaButton from '../../../../components/common/VegaButton';
import VegaText from '../../../../components/common/VegaText';
import { useSnackbar } from '../../../../providers/SnackbarProvider';
import { Ots, OtsAdditionalDocument } from '../../../../types/ots';
import { getErrorMessageFromErrorObj } from '../../../../utils/api';
import OtsFileDisplay from './OtsFileDisplay';

type Props = {
  open: boolean;
  onClose: () => void;
  ots?: Ots;
  onDownload: (url: string) => void;
};

function OtsDocumentsModal({ open, onClose, ots, onDownload }: Props) {
  const { setSnackbar } = useSnackbar();
  const [documents, setDocuments] = useState<OtsAdditionalDocument[]>([]);
  const [loading, setLoading] = useState<boolean>(false);

  async function fetchDocuments() {
    try {
      const otsId = ots?.id;
      if (!otsId) return;
      setLoading(true);
      const response = await OtsService.getDocuments(otsId);
      setDocuments(response);
    } catch (error) {
      setSnackbar(getErrorMessageFromErrorObj(error), 'error');
    } finally {
      setLoading(false);
    }
  }

  function handleClose() {
    onClose();
  }

  useEffect(() => {
    if (open == true && ots) {
      fetchDocuments();
    }
  }, [ots, open]);

  return (
    <LmDialog
      fullWidth
      maxWidth="sm"
      open={open}
      handleClose={() => {
        handleClose();
      }}
      buttonComponent={() => (
        <Stack
          width={'100%'}
          direction={'row'}
          alignItems={'end'}
          px={4}
          pb={4}
          gap={1}
        >
          <VegaButton
            variant="outlined"
            fullWidth
            text="Close"
            onClick={() => handleClose()}
          />
        </Stack>
      )}
      headerComponent={() => (
        <Stack
          direction={'row'}
          alignItems={'center'}
          px={4}
          py={2.5}
          gap={2}
          bgcolor={'#E5F7FC'}
        >
          <VegaText text="Documents" fontWeight={600} fontSize={'1.0625rem'} />
        </Stack>
      )}
    >
      <Stack spacing={'0.5rem'} padding="2rem" gap={'1rem'}>
        <Grid container gap={2}>
          {documents.map((i, index) => {
            return (
              <Grid item xs={12} key={i.id}>
                <OtsFileDisplay
                  value={i.fileName ?? 'File ' + index + 1}
                  onClick={() => {
                    onDownload(i.documentUrl);
                  }}
                />
              </Grid>
            );
          })}
        </Grid>
      </Stack>
    </LmDialog>
  );
}

export default OtsDocumentsModal;
